import { ICache } from "./ICache";
import { MemoryCache } from "./MemoryCache";

export class PromiseCache implements ICache {
    private _cache: MemoryCache;
    constructor() {
        this._cache = new MemoryCache(true);
    }
    public async get<T>(key: string, getter: () => Promise<T>): Promise<T> {
        return structuredClone(await this._cache.get(key, getter))!;
    }
    public set<T>(key: string, value: Promise<T>): void {
        this._cache.set(key, value);
    }
    public delete(key: string): void {
        this._cache.delete(key);
    }
}